class ContentPopup extends ModalDialog {
  constructor() {
    super();
    this.setOverflowHidden = this.dataset.overflowHidden == 'true';
    this.storageKey = this.dataset.key
    if (JSON.parse(localStorage.getItem(this.storageKey)) == true) return;
    if (JSON.parse(sessionStorage.getItem(this.storageKey)) == true) return;

    this.currentScroll = 0;
    this.setCurrentScroll();

    this.permanentCloseInput = this.querySelector('.content-popup__checkbox--input');
    if (this.permanentCloseInput) {
      this.permanentClosed = this.permanentCloseInput.checked || false;
      this.permanentCloseInput.addEventListener('change', this.onPermanentCloseChange.bind(this))
    }
    if (this.currentScroll >= this.dataset.scrollPercentage) {
      this.showPopup();
    } else {
      window.addEventListener('scroll', this.onScroll.bind(this))
    }
  }

  showPopup() {
    window.removeEventListener('scroll', this.onScroll.bind(this))
    if (JSON.parse(localStorage.getItem(this.storageKey)) == true) return;
    if (JSON.parse(sessionStorage.getItem(this.storageKey)) == true) return;
    setTimeout(() => {
      this.show(undefined);
      localStorage.setItem(this.storageKey, false)
      sessionStorage.setItem(this.storageKey, false)
    }, this.dataset.delay);
  }

  onPermanentCloseChange(event) {
    this.permanentClosed = event.target.checked
  }
  hide() {
    // Always open on Editor
    if (!Shopify.designMode) {
      if (this.permanentClosed)
        localStorage.setItem(this.storageKey, true)
      else
        sessionStorage.setItem(this.storageKey, true)
    }

    super.hide();
  }

  setCurrentScroll() {
    this.currentScroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0)
  }

  onScroll() {
    const documentHeight = document.documentElement.scrollHeight;
    this.setCurrentScroll();
    const currentPercentage = this.currentScroll / (documentHeight - window.innerHeight);

    if (currentPercentage >= this.dataset.scrollPercentage) {
      this.showPopup();
    }

  }

}

customElements.define('content-popup', ContentPopup)